import { message } from 'antd';

function getFileObjectName(file) {
  return file.substring(
    file.lastIndexOf('public/') + 7,
    file.lastIndexOf('?X')
  );
}

export default getFileObjectName;

export const validationUploadPayment = (file) => {
  const binaryFile = 1024;
  const maxSize = JSON.parse(process.env.REACT_APP_UPLOAD_LIMIT_PAYMENT);
  const fileSize = file.size / binaryFile;
  if (fileSize > maxSize) {
    message.error(
      `Please select a file less than ${(maxSize / binaryFile).toFixed(0)} MB`
    );
    return false;
  }
  return true;
};
